import { motion } from 'framer-motion'
import { Icon } from '@iconify/react'
import searchFill from '@iconify/icons-eva/search-fill'
// material
import {
  experimentalStyled as styled,
  useTheme,
} from '@material-ui/core/styles'
import {
  Box,
  alpha,
  Container,
  OutlinedInput,
  InputAdornment,
  Link,
  Grid,
  Typography,
  Chip,
  Avatar,
  Stack,
  AppBar,
  Toolbar,
  Button,
  IconButton,
  Divider,
} from '@material-ui/core'
//
import {
  varFadeInUp,
  TextAnimate,
  MotionInView,
  varWrapEnter,
  varFadeInRight,
  varFadeInDown,
  varFadeInLeft,
} from '../../animate'
import {
  Done,
  Email,
  Language,
  Message,
  Print,
  School,
  Wifi,
} from '@material-ui/icons'
import { useLocation, useNavigate, useParams } from 'react-router'
import Markdown from 'src/components/Markdown'
import RelatedCaseStudyCarousal from '../about/RelatedCaseStudyCarousal'
import { EcommerceNewProducts } from 'src/components/_dashboard/general-ecommerce'
import CaseStudyListItems from './CaseStudyListItems'
import { MIconButton } from 'src/components/@material-extend'
import { keyframes } from '@emotion/react'
import Maintenance from 'src/pages/Maintenance'
import { useRef } from 'react'
import HomeContactForm from './HomeContactForm'
import { data, stopdata } from './data'
import { Helmet } from 'react-helmet'

// ----------------------------------------------------------------------

const APP_BAR_MOBILE = 64
const APP_BAR_DESKTOP = 88
const APP_BAR_DESKTOP_SMALL = 52

const RootStyle = styled(motion.div)(({ theme }) => ({
  marginTop: '128px',
}))

// ----------------------------------------------------------------------

const ToolbarStyle1 = styled(Toolbar)(({ theme }) => ({
  height: APP_BAR_DESKTOP_SMALL,
  position: 'sticky',
  top: 0,
  zIndex: 1000,
  transition: theme.transitions.create(['height', 'background-color'], {
    easing: theme.transitions.easing.easeInOut,
    duration: theme.transitions.duration.shorter,
  }),
  backgroundColor: '#019bdc',
  [theme.breakpoints.up('md')]: {
    height: APP_BAR_DESKTOP_SMALL,
  },
}))

// Define the fade-in keyframes
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`

const RootStyle1 = styled(motion.div)(({ theme,pathname }) => ({
  position: 'relative',
  padding: theme.spacing(10, 0),
  opacity: 0,   
  animation: `${fadeIn} 0.5s ease-in forwards`,
  [theme.breakpoints.up('md')]: {
    height: 675,
    padding: 0,
  },
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background:  pathname=="/services/ai-development-company"||pathname=="/services/ai-automation-services"|| pathname=="/services/ai-integration-services"||pathname=="/services/ai-agents-for-business"?"":'linear-gradient(to right, rgba(255,255,255,1.1), rgba(255, 255, 255, 0))',
    //  color:  pathname=="/services/ai-development-company"||pathname=="/services/ai-automation-services"|| pathname=="/services/ai-integration-services"||pathname=="/services/ai-agents-for-business"?"#fff":'',
  },
}));

const ContentStyle = styled('div')(({ theme }) => ({
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    textAlign: 'left',
    position: 'absolute',
    top: theme.spacing(4.3),
  },
}))

export default function StopLandingPage() {
  const theme = useTheme()
  const navigate = useNavigate()
//   const { title } = useParams()
  const location = useLocation()
  const contactRef = useRef(null)
  // add (optional) helper
//   const isCemerem = title === 'skyniche-partnership-with-cemerem-2025'

  // Fetch the relevant data from the array if location.state is not available
  const newsData =
    location.state || stopdata

  // Destructure the news data
  const {
    date,
    imgSrc,
    imgSrc1,
    title,
    description,
    description1,
    category,
    subheading,
    points,
    pointsDescription,
    reflectionDescription,
    brandIdentity,
    SEO,
    time,
    designElements,
    conclusion,
    about_skyniche,
    aboutSkyniche,
    portal,
    contact,
    subtitle,
    aboutTheCollaboration,
    about,
    coveredDuringTheSession,
    coveredDuringTheSessionConclusion,
    impactOfTheSession,motto,vision,missionSubtitle,mission,whatMakesSTOPDifferent,corePhilosophy,whySTOP,commitment,
  } = newsData || {}

  // --- SEO: derive from data array with fallbacks (ADD) ---

  const { seo = {} } = newsData || {};

// Helper functions for cleaning and truncating text
const stripHtml = (s = '') => s.replace(/<[^>]*>/g, '').replace(/\s+/g, ' ').trim();
const truncate = (s = '', n = 160) => (s.length > n ? `${s.slice(0, n - 1).trim()}…` : s);  // Truncating description for SEO

  const seoTitle = seo.title  || 'News — skyniche Technologies';
  const seoDescription =
    seo.description ||
    truncate(stripHtml(description) || stripHtml(subheading) || 'Leader in custom software development, IT services, and solutions.', 160);
  const seoKeywords = Array.isArray(seo.keywords)
    ? seo.keywords.join(', ')
    : `${category || 'News'}, skyniche Technologies`;

  const canonicalUrl = seo.canonical || `${window.location.origin}${location.pathname}`;
  const ogImageRaw = seo.image || imgSrc1 || imgSrc;
  const ogImage = ogImageRaw
    ? (String(ogImageRaw).startsWith('http') ? ogImageRaw : `${window.location.origin}${ogImageRaw}`)
    : undefined;

  const robots = seo.noindex ? 'noindex,nofollow' : 'index,follow';
  const ogType = seo.type || 'article';
  const schemaType = seo.schemaType || 'NewsArticle';
  const publishedISO = (seo.publishedAt || date) ? new Date(seo.publishedAt || date).toISOString() : undefined;
  const orgName = 'skyniche Technologies';

  // Handle case when newsData is not found
  if (!newsData) {
    return <Maintenance />
  }

  const scrollToContact = () => {
    if (contactRef.current) {
      contactRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <RootStyle initial="initial" animate="animate" variants={varWrapEnter}>
      <Helmet>
      {/* Basic */}
      <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content={robots} />
        <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
        <meta property="og:site_name" content={orgName} />
        <meta property="og:url" content={canonicalUrl} />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        {ogImage && <meta property="og:image" content={ogImage} />}
        {seo?.imageAlt && (
          <meta property="og:image:alt" content={seo.imageAlt} />
        )}
        <meta property="og:locale" content="en_US" />
        {category && <meta property="article:section" content={category} />}
        {publishedISO && (
          <meta property="article:published_time" content={publishedISO} />
        )}
        {publishedISO && (
          <meta property="og:updated_time" content={publishedISO} />
        )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        {ogImage && <meta name="twitter:image" content={ogImage} />}

      {/* JSON-LD */}
      <script type="application/ld+json">
          {JSON.stringify({
            '@context': 'https://schema.org',
            '@type': schemaType,
            headline: seoTitle,
            description: seoDescription,
            datePublished: publishedISO,
            dateModified: publishedISO,
            author: { '@type': 'Organization', name: orgName },
            publisher: { '@type': 'Organization', name: orgName },
            image: ogImage ? [ogImage] : undefined,
            mainEntityOfPage: canonicalUrl,
            articleSection: category || undefined,
          })}
        </script>
      </Helmet>

      <Grid
        sx={{
          boxShadow: 0,
          height: '60px',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          marginTop: { xs: '-38px', sm: '-38px', md: 0 },
          marginBottom: { xs: '-3px', sm: '-3px', md: 0 },
        }}
      >
        <ToolbarStyle1 disableGutters>
          <Container
            maxWidth="lg"
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              mt: { xs: 0, sm: 0, md: -0.5 },
            }}
          >
            <Stack sx={{ display: 'flex', flexDirection: 'column' }}>
              {/* <MotionInView variants={varFadeInUp}>
                <Typography
                  sx={{
                    fontSize: '15px',
                    fontWeight: '600',
                    color: '#26efe9',
                    fontFamily:
                      '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial, sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                  }}
                >
                  About skyniche Technologies
                </Typography>
              </MotionInView> */}
              <MotionInView variants={varFadeInUp}>
                <Typography
                  sx={{
                    fontSize: '20px',
                    fontWeight: '600',
                    color: '#fff',
                    fontFamily:
                      '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial, sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                  }}
                >
                  STOP  
                </Typography>
              </MotionInView>
            </Stack>

            {imgSrc && (
              <MotionInView variants={varFadeInUp}>
                <Button
                  variant="outlined"
                  sx={{
                    color: '#c9fbfa',
                    border: '2px solid #c9fbfa',
                    fontWeight: '600',
                    borderRadius: 5,
                    fontFamily:
                      '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial, sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    '&:hover': {
                      border: '2px solid #c9fbfa',
                      color: '#c9fbfa',
                    },
                    backgroundColor: 'transparent',
                  }}
                  startIcon={
                    <Stack
                      className="tabler--message"
                      sx={{ fontSize: '1.4rem' }}
                    />
                  }
                  onClick={scrollToContact}
                >
                  Contact
                </Button>
              </MotionInView>
            )}
          </Container>
        </ToolbarStyle1>
      </Grid>
      {imgSrc ? (
        // <RootStyle1
        //   initial="initial"
        //   sx={{
        //     backgroundSize: 'cover',
        //     backgroundImage: `url(${imgSrc})`,
        //     backgroundPosition: 'center',
        //   }}
        //   animate="animate"
        //   variants={varWrapEnter}
        // >
        //   <Container
        //     maxWidth="lg"
        //     sx={{ position: 'relative', height: '100%' }}
        //   >

        //        <ContentStyle>
        //                     <Grid xs={12} sm={12} md={6}>
        //                       <MotionInView variants={varFadeInUp}>
        //                         <Typography dangerouslySetInnerHTML={{__html:motto}} sx={{textAlign:{xs:'center',sm:'center',md:'left'},zIndex:999,fontSize:{xs:'50px',sm:'60px',md:'73px'},lineHeight:1.2,fontWeight:'600',color:  '#019bdc',fontFamily: '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"', }}></Typography>
        //                       </MotionInView>
        //                     </Grid>
        //                 </ContentStyle>
        //   </Container>
        // </RootStyle1>
          <RootStyle1 initial="initial" sx={{  backgroundSize: 'cover',backgroundImage: `url(${imgSrc})`,}} animate="animate" variants={varWrapEnter}>
                <Container maxWidth="lg" sx={{ position: 'relative', height: '100%' }}>
                    <ContentStyle>
                        <Grid xs={12} sm={12} md={6}>
                          <MotionInView variants={varFadeInUp}>
                            <Typography dangerouslySetInnerHTML={{__html:motto }} sx={{textAlign:{xs:'center',sm:'center',md:'left'},zIndex:999,fontSize:{xs:'50px',sm:'60px',md:'73px'},lineHeight:1.2,fontWeight:'600',color:  '#019bdc',fontFamily: '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"', }}></Typography>
                          </MotionInView>
                        </Grid>
                    </ContentStyle>
                </Container>
              </RootStyle1>
      ) : (
        <Maintenance />
      )}
      {imgSrc && (
        <Box
          maxWidth="lg"
          sx={{
            pt: 5,
            pb: 3,
            pl: { xs: 3, sm: 3, md: 6 },
            pr: { xs: 3, sm: 3, md: 6 },
          }}
        >
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                mb: 2,
                pl: 2,
              }}
            >
              <MotionInView variants={varFadeInDown}>
                <Typography
                  sx={{
                    mb: 2,
                    fontSize: '2.3rem',
                    fontWeight: 400,
                    color: '#019bdc',
                    lineHeight: 1.2,
                    fontFamily:
                      '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                  }}
                >
                  {title}
                </Typography>
              </MotionInView>
              <Divider sx={{ mb: 1, borderColor: '#cccccc' }} />
              <Stack
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  flexDirection: 'row',
                  mt: -1,
                }}
              >
                <MotionInView variants={varFadeInUp}>
                  <MIconButton
                    onClick={() =>
                      (window.location.href = 'mailto:info@skyniche.com')
                    }
                  >
                    <Stack
                      className="fontisto--email"
                      sx={{ fontSize: '1.5rem' }}
                    />
                  </MIconButton>
                  <MIconButton
                    onClick={() =>
                      window.open(
                        'https://www.facebook.com/skyniche/',
                        '_blank',
                      )
                    }
                  >
                    <Stack
                      className="mingcute--facebook-line"
                      sx={{ fontSize: '1.5rem' }}
                    />
                  </MIconButton>
                  <MIconButton
                    onClick={() =>
                      window.open(
                        'https://www.instagram.com/skyniche_official/',
                        '_blank',
                      )
                    }
                  >
                    <Stack
                      className="ri--instagram-line"
                      sx={{ fontSize: '1.5rem' }}
                    />
                  </MIconButton>
                </MotionInView>
              </Stack>
              <Divider sx={{ mb: 2, borderColor: '#cccccc' }} />
              <MotionInView variants={varFadeInUp}>
                <Typography
                  sx={{
                    fontSize: '25px',
                    fontStyle: 'italic',
                    fontWeight: 500,
                    mb: 2,
                    color: '#019bdc',
                    lineHeight: 1.2,
                    fontFamily:
                      '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                  }}
                >
                  Over View :
                </Typography>
              </MotionInView>
              {description.map((item) => (
                <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      fontSize: '20px',
                      fontWeight: 400,
                      mb: 2,
                      color: '#000048',
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                    dangerouslySetInnerHTML={{ __html: item.text }}
                  ></Typography>
                </MotionInView>
              ))}
            </Grid>


            {vision && (
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  mb: 2,
                  pl: 2,
                }}
              >
                <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      fontSize: '25px',
                      fontStyle: 'italic',
                      fontWeight: 500,
                      mb: 2,
                      color: '#019bdc',
                      lineHeight: 1.2,
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                  >
                    Vision
                  </Typography>
                </MotionInView>
                <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      fontSize: '20px',
                      fontWeight: 400,
                      mb: 2,
                      color: '#000048',
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: vision,
                    }}
                  ></Typography>
                </MotionInView>
              </Grid>
            )}


             {missionSubtitle && (
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  mb: 2,
                  pl: 2,
                }}
              >
                <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      fontSize: '25px',
                      fontStyle: 'italic',
                      fontWeight: 500,
                      mb: 2,
                      color: '#019bdc',
                      lineHeight: 1.2,
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                  >
                    {missionSubtitle}
                  </Typography>
                </MotionInView>
            
              </Grid>
            )}
            {mission?.length > 0 && (
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  pl: 2,
                }}
              >
                <MotionInView variants={varFadeInUp}>
                  <Typography sx={{ mb: 2, pl: 4 }}>
                    <Box component={'ul'}>
                      {mission.map((point, index) => (
                        <Typography
                          component={'li'}
                          sx={{
                            mb: 1,
                            fontSize: '19px',
                            fontWeight: 400,
                            color: '#000048',
                          }}
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        ></Typography>
                      ))}
                    </Box>
                  </Typography>
                </MotionInView>
              </Grid>
            )}

            {/*corePhilosophy start  */}

            {corePhilosophy && (
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  mb: 2,
                  pl: 2,
                }}
              >
                <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      fontSize: '25px',
                      fontStyle: 'italic',
                      fontWeight: 500,
                      mb: 2,
                      color: '#019bdc',
                      lineHeight: 1.2,
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                  >
                   Core Philosophy
                  </Typography>
                </MotionInView>

                 <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      fontSize: '20px',
                      fontWeight: 400,
                      mb: 2,
                      color: '#000048',
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                  >
                  {corePhilosophy?.subtitle}
                  </Typography>
                </MotionInView>
              </Grid>
            )}
            {corePhilosophy?.points?.length > 0 && (
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  pl: 2,
                }}
              >
                <MotionInView variants={varFadeInUp}>
                  <Typography sx={{ mb: 2, pl: 4 }}>
                    <Box component={'ul'}>
                      {corePhilosophy?.points.map((point, index) => (
                        <Typography
                          component={'li'}
                          sx={{
                            mb: 1,
                            fontSize: '19px',
                            fontWeight: 400,
                            color: '#000048',
                          }}
                          key={index}
                          dangerouslySetInnerHTML={{ __html: point }}
                        ></Typography>
                      ))}
                    </Box>
                  </Typography>
                </MotionInView>
                <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      ml: 3,
                      fontSize: '20px',
                      fontWeight: 400,
                      mb: 2,
                      color: '#000048',
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                    dangerouslySetInnerHTML={{
                      __html: corePhilosophy?.conclusion,
                    }}
                  ></Typography>
                </MotionInView>
              </Grid>
            )}
            {/* coveredDuringTheSession end*/}


           
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  mb: 2,
                  pl: 2,
                }}
              >
                <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      fontSize: '25px',
                      fontStyle: 'italic',
                      fontWeight: 500,
                      mb: 2,
                      color: '#019bdc',
                      lineHeight: 1.2,
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                  >
                 Why STOP
                  </Typography>
                </MotionInView>

                {whySTOP && (
                  <MotionInView variants={varFadeInUp}>
                    <Typography
                      sx={{
                        fontSize: '20px',
                        fontWeight: 400,
                        mb: 2,
                        color: '#000048',
                        fontFamily:
                          '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                      }}
                      dangerouslySetInnerHTML={{
                        __html: whySTOP,
                      }}
                    />
                  </MotionInView>
                )}
              </Grid>
          
           
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: 'flex',
                  justifyContent: 'flex-start',
                  flexDirection: 'column',
                  mb: 2,
                  pl: 2,
                }}
              >
                <MotionInView variants={varFadeInUp}>
                  <Typography
                    sx={{
                      fontSize: '25px',
                      fontStyle: 'italic',
                      fontWeight: 500,
                      mb: 2,
                      color: '#019bdc',
                      lineHeight: 1.2,
                      fontFamily:
                        '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                    }}
                  >
                   Commitments
                  </Typography>
                </MotionInView>

                {commitment && (
                  <MotionInView variants={varFadeInUp}>
                    <Typography
                      sx={{
                        fontSize: '20px',
                        fontWeight: 400,
                        mb: 2,
                        color: '#000048',
                        fontFamily:
                          '"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
                      }}
                      dangerouslySetInnerHTML={{
                        __html: commitment,
                      }}
                    />
                  </MotionInView>
                )}
              </Grid>
 
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: 'flex',
                justifyContent: 'flex-start',
                flexDirection: 'column',
                mb: 2,
                pl: 2,
              }}
            >
             
            </Grid>
          </Grid>
          <Box sx={{ mt: -2 }} ref={contactRef}>
            <HomeContactForm />
          </Box>
        </Box>
      )}
    </RootStyle>
  )
}
